<template>
	<page>
		<v-card>
			<v-card-actions class="d-md-none">
				<v-row no-gutters>
					<v-col cols="12">
						<v-btn class="btn-mobile ma-1 " block v-if="isManager || isBranchClient" slot="actions" color="success" btn @click="onEdit({measurements:[],project:{}})">
							{{ $t("pages.orderView.privateCustomerForm") }}
						</v-btn>
						<v-btn class="btn-mobile blue" block v-if="isSurveyor" slot="actions" color="primary" btn @click.stop="exportDaily">
							סידור עבודה
						</v-btn>
						<v-btn class="btn-mobile ma-1" block v-if="isManager || isBranchClient" color="success" btn @click="openConstructOrder({client_id:null,branch_id:null})">{{ $t("pages.orderView.constrationSiteForm") }}</v-btn>
						<v-btn class="btn-mobile blue" block v-if="!isClient" slot="actions" color="primary" btn @click.stop="downloadFile">
							<v-icon dark>mdi-download</v-icon>
							הורדת קבצים
						</v-btn>
						<v-btn class="btn-mobile blue" block v-if="!isSurveyor" slot="actions" color="primary" btn @click.stop="exportExcel">
							<v-icon light>mdi-file-download-outline</v-icon>
							יצוא טבלה
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
			<v-expansion-panels v-model="panel">
				<v-expansion-panel>
					<v-expansion-panel-header style="height: 55px;">
						<h3>
							<v-icon>mdi-chevron-down</v-icon>
							{{ $t("attributes.screen") }} {{ $t("attributes.orders") }} - {{ $t("pages.orderView.filterOptions") }}
						</h3>
						<v-btn class="btn-title green d-xs-none" v-if="isManager || isBranchClient  || isClientManager" slot="actions" color="success" btn @click.stop="onEdit({measurements:[],project:{}})">
							{{ $t("pages.orderView.privateCustomerForm") }}
						</v-btn>
						<v-btn class="btn-title green d-xs-none" v-if="isManager || isBranchClient || isClientManager" slot="actions" color="success" btn @click.stop="openConstructOrder({client_id:null,branch_id:null})">{{ $t("pages.orderView.constrationSiteForm") }}</v-btn>
						<v-btn class="btn-title blue d-xs-none" v-if="!isSurveyor" slot="actions" color="primary" btn @click.stop="exportExcel">
							<v-icon light>mdi-file-download-outline</v-icon>
							יצוא טבלה
						</v-btn>
						<v-btn class="btn-title blue d-xs-none" v-if="isSurveyor" slot="actions" color="primary" btn @click.stop="exportDaily">
							סידור עבודה
						</v-btn>
						<v-btn class="btn-title blue d-xs-none" v-if="!isClient" slot="actions" color="primary" btn @click.stop="downloadFile">
							<v-icon dark>mdi-download</v-icon>
							הורדת קבצים
						</v-btn>
						<v-btn class="btn-title blue d-xs-none" v-if="!isSurveyor" slot="actions" color="success" btn @click.stop="openImportModal({})">
							ייבוא
						</v-btn>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<order-filter v-model="filters"/>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-card>
		<row v-if="isSurveyor">
			<c-col>
				<h3 style="background-color: yellow;color: red" class="text-center">מודד יקר ! נא להקפיד לציין על כל מדידה פרטי מעלית / דרכי גישה / חדר מדרגות / מנוף, תודה. יום מקסים (-:</h3>
			</c-col>
		</row>
		<row>
			<c-col>
				<measurements-table
					ref="mTable"
					@edit="onEdit"
					:search="filters"
					@cancel="cancelMeasurment"
					@duplicate="duplicateMeasurement"
					@another="anotherMeasurment"
					@duplicateClient="duplicateClientOrder"
					@accept="openAcceptModal"/>
			</c-col>
		</row>
		<full-screen-dialog v-model="openModal">
			<v-container>
				<span slot="header">{{ $t("pages.orderView.privateCustomerForm") }}</span>
				<order-form v-if="openModal" @save="onSave" :current-measurement="currentMeasurement"/>
			</v-container>
		</full-screen-dialog>
		<full-screen-dialog v-model="constructModal">
			<v-container>
				<span slot="header">{{ $t("pages.orderView.constrationSiteForm") }}</span>
				<construction-form v-if="constructModal" @save="onSave" :current-measurement="currentMeasurement"/>
			</v-container>
		</full-screen-dialog>

		<popup-dialog v-if="cancelOpenModal" v-model="cancelOpenModal">
			<span slot="header">{{ $t("pages.orderView.cancelOrder") }}</span>
			<cancel-select :measurements="tempItem" @closeDialog="cancelOpenModal=false" :isSurveyor="isSurveyor"/>
		</popup-dialog>

		<popup-dialog v-model="anotherOpenModal">
			<span slot="header">{{ $t("pages.orderView.addOrder") }}</span>
			<measurement-form @save="openModal=false" :canSave="true" :measurement="tempItem" @closeDialog="closeAnother"/>
		</popup-dialog>
		<project-import-dialog v-if="importModal" @save="onImportSave" v-model="importModal"></project-import-dialog>

		<popup-dialog v-model="HTMModal">
			<span slot="header">HTM\MNS</span>
			<htm-form v-if="HTMModal" @save="HTMModal=false"/>
		</popup-dialog>

		<popup-dialog v-model="acceptModal">
			<accept-form v-if="acceptModal && measurementToAccept" :measurements="measurementToAccept" @save="acceptModal=false" @close="acceptModal=false"/>
		</popup-dialog>

	</page>
</template>

<script>
	import OrderForm from "src/view/orders/OrderForm";
	import FullScreenDialog from "dev/scaffoldings/FullScreenDialog";
	import MeasurementsTable from "dev/view/measurements/MeasurementsTable";
	import OrderModule from "src/store/modules/Order.module";
	import {types as ProjectType} from "dev/store/modules/Project.module";
	import ConstructionForm from "dev/view/orders/ConstructionForm";
	import OrderFilter from "dev/view/orders/OrderFilter";
	import CancelSelect from "dev/view/measurements/CancelSelect";
	import MeasurementForm from "dev/view/measurements/MeasurementForm";
	import {types as statusTypes} from "dev/helpers/StatusManager";
	import {types as MeasurementType} from "dev/store/modules/Measurement.module";
	import HtmForm from "dev/view/measurements/HTMForm";
	import moment from "moment";
	import AcceptForm from "dev/view/measurements/AcceptForm";
	import ProjectImportDialog from "dev/view/import/ProjectImportDialog";
	import Swal from "sweetalert2";

	export default {
		name: "orders-view",
		components: {
			ProjectImportDialog,
			AcceptForm,
			HtmForm,
			MeasurementForm,
			CancelSelect, OrderFilter, ConstructionForm, MeasurementsTable, FullScreenDialog, OrderForm
		},
		data() {
			return {
				panel: false,
				openModal: false,
				acceptModal: false,
				constructModal: false,
				measurementToAccept: null,
				filters: {
					order_num: null,
					company_name: null,
					company_branch: null,
					"status[]": [],
					"surveyor[]": [],
					branches: [],
					startCreatedAt: null,
					endCreatedAt: null,
					beginStartDate: null,
					untilStartDate: null,
					beginEndDate: null,
					untilEndDate: null,
					clientName: null,
					recheck: null,
					city: null,
					Deleted: null,
					ordersCustomer: null
				},
				cancelOpenModal: false,
				anotherOpenModal: false,
				tempItem: null,
				currentMeasurement: null,
				HTMModal: false,
				importModal: false
			};
		},
		computed: {
			isMobile() {
				return (window.innerWidth < 600);
			},
      auth() {
        return this.$store.state.AuthModule.user;
      },
			dateNow() {
				return moment().format("YYYY-MM-DDTHH:mm:ss");
			},

			isSurveyor() {
				return this.$store.getters.isSurveyor;
			}, isBranchClient() {
				return this.$store.getters.isBranchClient;
			},
			isManager() {
				return this.$store.getters.isManager;
			},
			isClient() {
				return this.$store.getters.isClient;
			},
    isClientManager() {
				return this.$store.getters.isClientManager;
			},
			clientRole() {
				return this.$store.getters.isRole;
			},
			basicUrl() {
				return this.$store.state.ConfigModule.request.baseUrl;
			},
		},

		methods: {
			onImportSave(){
				this.$refs.mTable.getData();
			},
			getFilters() {
				let query = new URLSearchParams();
				Object.keys(this.filters).forEach(key => {
					let value = this.filters[key];
					if (value) {
						if (Array.isArray(value)) {
							if (value.length) {
								value.forEach(val => query.append(key, val));
							}
						} else {
							query.set(key, value);
						}
					}
				});
				return query;
			},
			async duplicateClientOrder(item){

				let swal  = await Swal.fire({

					title:"האם לחדש הזמנה זאת?",

					showConfirmButton:true,

					confirmButtonColor:"#333eaF",

					confirmButtonText:"חדש",

					showCancelButton:true,

					cancelButtonText:"בטל"

				});

				if(swal.value){

					await this.$store.dispatch(MeasurementType.RENEW,item);

				}else{

					return;

				}

			},
			exportExcel() {
				window.open(`${this.basicUrl}/measurements/export?a=1&${this.getFilters()}`);
			},
			exportDaily() {
				window.open(`${this.basicUrl}/measurements/daily?a=1&${this.getFilters()}`);
			},
			downloadFile() {
				window.open(`${this.basicUrl}/measurements/download?a=1&${this.getFilters()}`);
			},
			openAcceptModal(item) {
				if (!Array.isArray(item)) {
					item = [item];
				}
				this.measurementToAccept = item.map((item) => {
					if (isNaN(item)) {
						return item.id;
					}
					return item;
				});
				this.acceptModal = true;
			},
			queryObj() {
				const query = {orderBy: "name"};
				for (let filter in this.filters) {
					if (this.filters[filter].length) {
						if (Array.isArray(this.filters[filter])) {
							query[filter] = this.filters[filter].join(",");
						} else {
							query[filter] = this.filters[filter];
						}
					}
				}
				return query;
			},

			duplicateMeasurement(measurement) {
				this.HTMModal = true;
				this.$store.commit(MeasurementType.GET, measurement);

			},
			closeAnother() {
				this.anotherOpenModal = false;
			},

			searchParams(filters) {
				this.filters = filters;
			},
			anotherMeasurment(item) {
				this.anotherOpenModal = true;
				this.tempItem = {
					order_id: item.order_id,
					status: statusTypes.DO_AGAIN,
					surveyor_id: item.surveyor_id,
					start_date: item.start_date,
					end_date: this.dateNow
				};
			},

			cancelMeasurment(item) {
				if (!Array.isArray(item)) {
					item = [item];
				}
				this.tempItem = item.map((item) => {
					if (isNaN(item)) {
						return item.id;
					}
					return item;
				});
				this.cancelOpenModal = true;
			},
			openImportModal(order){
				this.$store.commit(ProjectType.CREATE, order);
				this.importModal = true;
			},
			openConstructOrder(order) {
				if (order.id) {
					this.$store.commit(ProjectType.GET, order);
				} else {
					this.$store.commit(ProjectType.CREATE, Object.assign({}, order,{client_id:this.auth.client_id}));
				}
				this.constructModal = true;
			},
			async onEdit(measurement) {
				this.currentMeasurement = null;
				if (measurement.id) {
					this.currentMeasurement = measurement;
					if (+measurement.projects_type === ProjectType.CONSTRUCTION_TYPE) {
						await this.$store.dispatch(ProjectType.GET, measurement.projects_id);
						this.constructModal = true;
					} else {
						await this.$store.dispatch(OrderModule.types.GET, measurement.order_id);
						this.openModal = true;
					}
				} else {
					this.$store.commit(OrderModule.types.CREATE, Object.assign({}, measurement,{project: {client_id:this.auth.client_id,branch_id:this.auth.branch_id}}));
					this.openModal = true;
				}
			},
			onSave() {
				this.$refs.mTable.getData();
				this.currentMeasurement = null;
				this.openModal = false;
				this.constructModal = false;
			}


		},
		created: function () {
			let queryParams = {};
			Object.keys(this.$route.query).map((key) => {
				if (Array.isArray(this.$route.query[key])) {
					queryParams[key] = this.$route.query[key].map(value => {
						return isNaN(value) ? value : +value;
					});
					return;
				}
				queryParams[key] = isNaN(this.$route.query[key]) ? this.$route.query[key] : +this.$route.query[key];
			});
			this.filters = Object.assign({}, this.filters, queryParams);
		}

	};
</script>

<style scoped>
.btn-title {
  height: 30px !important;
  margin: 5px;
}

.green {
  background-color: #016f20;
  background-image: -webkit-linear-gradient(90deg, #016f20, #00c853);
}

.blue {
  background-color: #016b6f;
  background-image: -webkit-linear-gradient(90deg, #011d6f, #0032c8);
}


.btn-mobile {
  /*width: 48%;*/
  height: 30px !important;
  font-size: 12px;
  /*margin: 2px 2px 5px;*/
}

@media (max-width: 750px) {
  .btn-title {
    display: none;
  }
}

</style>
